var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileupload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2L6.52157 1.46105L6 0.956307L5.47843 1.46105L6 2ZM5.25 10C5.25 10.4142 5.58579 10.75 6 10.75C6.41421 10.75 6.75 10.4142 6.75 10H5.25ZM9.47843 6.40992C9.77609 6.69797 10.2509 6.69019 10.539 6.39253C10.827 6.09488 10.8192 5.62007 10.5216 5.33202L9.47843 6.40992ZM1.47843 5.33202C1.18078 5.62007 1.173 6.09488 1.46105 6.39253C1.7491 6.69019 2.22391 6.69797 2.52157 6.40992L1.47843 5.33202ZM5.25 2V10H6.75V2H5.25ZM5.47843 2.53895L9.47843 6.40992L10.5216 5.33202L6.52157 1.46105L5.47843 2.53895ZM5.47843 1.46105L1.47843 5.33202L2.52157 6.40992L6.52157 2.53895L5.47843 1.46105Z",
    fill: "#26303E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#26303E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileupload);
export default __webpack_public_path__ + "static/media/fileupload.a917bfc1.svg";
export { ForwardRef as ReactComponent };